module.exports = __webpack_public_path__ + "static/innovate-70fbd7b3985e4e02fa0662a962154ca8.png";